import Image from 'next/image';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const ContentWrapper = styled.div`
  max-width: 1240px;
  margin: 40px auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 0 auto;
  }
`;

export const IframeWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

export const TextContentWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 25px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 0 15px;
  }
`;

export const BannerWrapper = styled.div`
  width: 100%;
  height: 500px;
  margin-bottom: 40px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 250px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 129px;
  }
`;

export const BannerWrapperDetail = styled.div`
  width: 100%;
  height: 500px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: auto;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: auto;
  }
`;

export const Banner = styled(Image)`
  position: relative !important;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    object-fit: cover;
    border-radius: 0;
  }
`;

export const Title = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 14px;
  margin-top: -15px;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 24px;
    margin-bottom: 11px;
  }
`;
export const TitleMobile = styled.span`
  font-size: 36px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 14px;
  margin-top: -10px;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 24px;
    margin-bottom: 11px;
  }
`;
export const Description = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 40px;
  line-height: 1.5;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    margin-bottom: 30px;
  }
`;

export const PromotionItemsDetail = styled.div<{ item: number }>`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(item, 295px);
  grid-template-rows: 270px;
  gap: 0 20px;
  margin-bottom: 70px;
  grid-auto-columns: 295px;
  grid-auto-flow: column;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 30px;
    justify-content: inherit;
  }
`;
export const PromotionItems = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 295px);
  grid-template-rows: 270px;
  gap: 0 20px;
  margin-bottom: 70px;
  grid-auto-columns: 410px;
  grid-auto-flow: column;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 30px;
  }
`;

export const PromotionItem = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
`;
export const PromotionImage = styled(Image)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  top: 0;
  left: 0;
  border-radius: 8px;
`;
export const PromotionLayer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
`;
export const PromotionContent = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
`;
export const PromotionTitle = styled.span`
  font-size: 24px;
  color: ${({ theme }) => theme.palette.white};
  margin-bottom: 15px;
  line-height: 1.17;
  display: block;
  font-weight: bold;
`;
export const PromotionDescription = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.white};
`;
export const PromotionBorder = styled.div`
  width: 36px;
  height: 6px;
  margin-bottom: 15px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.coral};
`;

export const Label = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-bottom: 26px;
  display: block;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
    margin-bottom: 15px;
  }
`;

export const ConditionsItem = styled.div`
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 10px 1fr;
  gap: 0 20px;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 0 5px;
  }
`;
export const ConditionsText = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.darkGrey};
  line-height: 1.5;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
  }
`;
export const ConditionsDot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
  }
  background-color: ${({ theme }) => theme.palette.coral};
`;
